const defaultDropdown = [
  {
    title: 'Afmelden',
    icon: 'glyphicon-log-out',
    event: 'logout'
  },
  {
    title: 'Instellingen',
    icon: 'glyphicon-cog',
    event: 'settings'
  }
];

class HeaderBar {

  constructor($scope){
    'ngInject';
    this.$scope = $scope;
    this.initials = '';
    this.showLogin = false;

  }

  $onInit() {
    if(!this.user) this.showLogin = true;
    this.initials = this.getInitials(this.user);
    if(!this.dropdown) this.dropdown = defaultDropdown;
    if(this.logoSize != 'sm') this.logoSize = 'lg';
  }

  onLogoClick() {
    this.$scope.$emit('onLogoClicked');
  }

  dropdownEmitter(evType){
    this.$scope.$emit('onDropdownClicked', evType);
  }

  onLoginEmitter(){
    this.$scope.$emit('onLogin');
  }

  $onChanges(bindings){
    if(bindings.user){
      this.showLogin = false;
      this.user = bindings.user.currentValue;
      this.initials = this.getInitials(this.user);
    }
    if(bindings.dropdown && bindings.dropdown.currentValue == null) this.dropdown = defaultDropdown;
  }

  getInitials(user){
    let initials = {
      first: '',
      second: ''
    };

    if(user){
      if(user.firstName) initials.first = user.firstName.toUpperCase().charAt(0);
      if(user.lastName) initials.second = user.lastName.toUpperCase().charAt(0);
    }

    return initials.first + initials.second;
  }

}


module.exports = {
  template: require('./kovHeaderBar.html'),
  controllerAs: 'ctrl',
  controller: HeaderBar,
  bindings:{
    title: '@',
    icon: '@',
    user: '<person',
    logoSize: '@',
    dropdown: '<'
  } ,
  transclude: true
};
